












































import { Component, Prop, Vue } from 'vue-property-decorator';

import ProjectBreadcrumb from '@/views/components/projects/ProjectBreadcrumb.vue';

import { agencyStore } from '@/store/store';

import NewAsphaltScenarioInfo from '@/modules/design/views/asphalt/1-AsphaltScenarioInfo.vue';
import NewAsphaltDesignParameters from '@/modules/design/views/asphalt/2-AsphaltDesignParameters.vue';
import { BaseScenarioType } from '@/lib/types/IBaseScenario';


@Component({
  components: {
    ProjectBreadcrumb,
    ScenarioInfo: NewAsphaltScenarioInfo,
    DesignParameters: NewAsphaltDesignParameters,
  },
})
export default class AgencyCostComparisonContainer extends Vue {
  @Prop() pages!: { link: string, text: string }[];

  @Prop() pxModuleId!: number;

  @Prop() numScenarios!: number;

  scenarioType = BaseScenarioType.agencyCost;

  get currentProjectMetadata() {
    return agencyStore.comparisonProject;
  }

  mounted() {
  }

  public displayImperial: boolean = true;

  get currentUnitSystemIsImperial() {
    return true;
  }

  saveUnitSelection() {
    // if (this.displayImperial) {
    //   lccaStore.setDisplayUnits(UnitSystem.Imperial);
    // } else {
    //   lccaStore.setDisplayUnits(UnitSystem.Metric);
    // }
  }
}
